module.exports = __webpack_public_path__ + "img/icon-error.e69ee806.svg";